// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__28QK_","name":"ConsentHeader_name__3cLED","birthday":"ConsentHeader_birthday__1KlbR","skeleton":"ConsentHeader_skeleton__1BoEv"};